/**
 * Acciones del juego que se ejecutan desde RPCode
 * Estas funciones se conectan con la base de datos y la lógica del juego
 */

// Importar servicios necesarios (ajustar según tu estructura)
// import { adventureService } from '../../services/adventure.services';
// import { characterService } from '../../services/character.services';

/**
 * Acciones de navegación
 */
export const leaveAdventure = async (parameters, context) => {
  try {
    const { characterId, adventureId } = context

    // Aquí iría la llamada real a tu API
    // await adventureService.leaveAdventure(characterId, adventureId);

    console.log('🚪 Personaje abandona la aventura', { characterId, adventureId })

    return {
      success: true,
      message: 'Has abandonado la aventura',
      redirect: '/aventuras', // Opcional: redirigir después
    }
  } catch (error) {
    throw new Error(`No se pudo abandonar la aventura: ${error.message}`)
  }
}

export const joinAdventure = async (parameters, context) => {
  try {
    const { adventureId } = parameters
    const { characterId } = context

    // await adventureService.joinAdventure(characterId, adventureId);

    console.log('🚪 Personaje se une a la aventura', { characterId, adventureId })

    return {
      success: true,
      message: `Te has unido a la aventura ${adventureId}`,
      redirect: `/aventura/${adventureId}`,
    }
  } catch (error) {
    throw new Error(`No se pudo unir a la aventura: ${error.message}`)
  }
}

/**
 * Acciones de combate
 */
export const attackTarget = async (parameters, context) => {
  try {
    const { targetId, weaponType = 'fists' } = parameters
    const { characterId, adventureId } = context

    // Simular cálculo de daño (aquí iría tu lógica real)
    const damage = Math.floor(Math.random() * 20) + 1
    const criticalHit = Math.random() < 0.1 // 10% probabilidad crítico

    // await combatService.performAttack(characterId, targetId, weaponType);

    console.log('⚔️ Ataque realizado', { characterId, targetId, weaponType, damage, criticalHit })

    return {
      success: true,
      damage: criticalHit ? damage * 2 : damage,
      critical: criticalHit,
      weapon: weaponType,
      target: targetId,
      message: `Atacas a ${targetId} con ${weaponType} causando ${damage} de daño${criticalHit ? ' ¡CRÍTICO!' : ''}`,
    }
  } catch (error) {
    throw new Error(`Error en el ataque: ${error.message}`)
  }
}

export const defendSelf = async (parameters, context) => {
  try {
    const { characterId } = context

    // await combatService.setDefensiveStance(characterId);

    console.log('🛡️ Personaje se defiende', { characterId })

    return {
      success: true,
      defenseBonus: 5,
      duration: 3, // turnos
      message: 'Adoptas una posición defensiva (+5 defensa por 3 turnos)',
    }
  } catch (error) {
    throw new Error(`Error al defenderse: ${error.message}`)
  }
}

export const fleeFromCombat = async (parameters, context) => {
  try {
    const { characterId, adventureId } = context

    // Tirada de huida basada en estadísticas del personaje
    const fleeRoll = Math.floor(Math.random() * 20) + 1
    const agilityBonus = context.character?.agility || 0
    const totalRoll = fleeRoll + Math.floor(agilityBonus / 2)
    const success = totalRoll >= 12

    if (success) {
      // await adventureService.removeFromCombat(characterId, adventureId);
    }

    console.log('🏃 Intento de huida', { characterId, fleeRoll, agilityBonus, totalRoll, success })

    return {
      success,
      roll: fleeRoll,
      bonus: Math.floor(agilityBonus / 2),
      total: totalRoll,
      message: success ? 'Has huido exitosamente del combate' : 'No pudiste escapar, sigues en combate',
    }
  } catch (error) {
    throw new Error(`Error al huir: ${error.message}`)
  }
}

/**
 * Acciones de magia
 */
export const castSpell = async (parameters, context) => {
  try {
    const { spellName, targetId } = parameters
    const { characterId } = context

    // Verificar si el personaje conoce el hechizo y tiene maná
    const manaCost = getSpellManaCost(spellName)
    const currentMana = context.character?.mana || 0

    if (currentMana < manaCost) {
      throw new Error('No tienes suficiente maná')
    }

    const spellPower = Math.floor(Math.random() * 15) + 10

    // await magicService.castSpell(characterId, spellName, targetId, spellPower);

    console.log('✨ Hechizo lanzado', { characterId, spellName, targetId, manaCost, spellPower })

    return {
      success: true,
      spell: spellName,
      manaCost,
      power: spellPower,
      target: targetId,
      message: `Lanzas ${spellName}${targetId ? ` contra ${targetId}` : ''} (${manaCost} maná) con poder ${spellPower}`,
    }
  } catch (error) {
    throw new Error(`Error al lanzar hechizo: ${error.message}`)
  }
}

export const healTarget = async (parameters, context) => {
  try {
    const { targetId, healAmount } = parameters
    const { characterId } = context

    const actualHeal = parseInt(healAmount) || Math.floor(Math.random() * 20) + 10
    const manaCost = Math.floor(actualHeal / 2)

    // await magicService.healTarget(characterId, targetId, actualHeal);

    console.log('💚 Curación realizada', { characterId, targetId, healAmount: actualHeal, manaCost })

    return {
      success: true,
      healAmount: actualHeal,
      manaCost,
      target: targetId || 'self',
      message: `Curas ${actualHeal} puntos de vida a ${targetId || 'ti mismo'} (${manaCost} maná)`,
    }
  } catch (error) {
    throw new Error(`Error al curar: ${error.message}`)
  }
}

/**
 * Acciones de inventario
 */
export const useItem = async (parameters, context) => {
  try {
    const { itemId, targetId } = parameters
    const { characterId } = context

    // Verificar si el personaje tiene el objeto
    // const hasItem = await inventoryService.hasItem(characterId, itemId);
    // if (!hasItem) throw new Error('No tienes ese objeto');

    // await inventoryService.useItem(characterId, itemId, targetId);

    console.log('🎒 Objeto usado', { characterId, itemId, targetId })

    return {
      success: true,
      item: itemId,
      target: targetId,
      message: `Usas ${itemId}${targetId ? ` en ${targetId}` : ''}`,
    }
  } catch (error) {
    throw new Error(`Error al usar objeto: ${error.message}`)
  }
}

export const equipItem = async (parameters, context) => {
  try {
    const { itemId } = parameters
    const { characterId } = context

    // await inventoryService.equipItem(characterId, itemId);

    console.log('⚔️ Objeto equipado', { characterId, itemId })

    return {
      success: true,
      item: itemId,
      message: `Equipas ${itemId}`,
    }
  } catch (error) {
    throw new Error(`Error al equipar objeto: ${error.message}`)
  }
}

/**
 * Acciones de información
 */
export const showCharacterStats = async (parameters, context) => {
  try {
    const { characterId } = context

    // const stats = await characterService.getStats(characterId);

    // Simular estadísticas
    const stats = {
      level: context.character?.level || 1,
      health: context.character?.health || 100,
      mana: context.character?.mana || 50,
      strength: context.character?.strength || 10,
      agility: context.character?.agility || 10,
      intelligence: context.character?.intelligence || 10,
    }

    console.log('📊 Estadísticas mostradas', { characterId, stats })

    return {
      success: true,
      stats,
      message: 'Estadísticas del personaje mostradas',
    }
  } catch (error) {
    throw new Error(`Error al mostrar estadísticas: ${error.message}`)
  }
}

export const showInventory = async (parameters, context) => {
  try {
    const { characterId } = context

    // const inventory = await inventoryService.getInventory(characterId);

    console.log('🎒 Inventario mostrado', { characterId })

    return {
      success: true,
      message: 'Inventario del personaje mostrado',
    }
  } catch (error) {
    throw new Error(`Error al mostrar inventario: ${error.message}`)
  }
}

/**
 * Acciones sociales
 */
export const whisperToPlayer = async (parameters, context) => {
  try {
    const { playerId, message } = parameters
    const { characterId } = context

    // await socialService.sendWhisper(characterId, playerId, message);

    console.log('💬 Susurro enviado', { from: characterId, to: playerId, message })

    return {
      success: true,
      recipient: playerId,
      message: `Susurras a ${playerId}: "${message}"`,
    }
  } catch (error) {
    throw new Error(`Error al susurrar: ${error.message}`)
  }
}

export const shoutMessage = async (parameters, context) => {
  try {
    const { message } = parameters
    const { characterId, adventureId } = context

    // await socialService.shoutInAdventure(characterId, adventureId, message);

    console.log('📢 Grito enviado', { characterId, adventureId, message })

    return {
      success: true,
      message: `Gritas: "${message}"`,
    }
  } catch (error) {
    throw new Error(`Error al gritar: ${error.message}`)
  }
}

/**
 * Acciones de dados y tiradas
 */
export const rollDice = async (parameters, context) => {
  try {
    const sides = parseInt(parameters.sides) || 20
    const count = parseInt(parameters.count) || 1

    const rolls = []
    let total = 0

    for (let i = 0; i < count; i++) {
      const roll = Math.floor(Math.random() * sides) + 1
      rolls.push(roll)
      total += roll
    }

    console.log('🎲 Dados lanzados', { sides, count, rolls, total })

    return {
      success: true,
      rolls,
      total,
      sides,
      count,
    }
  } catch (error) {
    throw new Error(`Error al lanzar dados: ${error.message}`)
  }
}

export const skillCheck = async (parameters, context) => {
  try {
    const { skill, difficulty = 15 } = parameters
    const { characterId } = context

    // Obtener modificador de habilidad del personaje
    const skillModifier = getSkillModifier(skill, context.character)
    const roll = Math.floor(Math.random() * 20) + 1
    const total = roll + skillModifier
    const success = total >= parseInt(difficulty)

    console.log('🎯 Tirada de habilidad', { characterId, skill, roll, skillModifier, total, difficulty, success })

    return {
      success: true,
      skill,
      roll,
      modifier: skillModifier,
      total,
      difficulty: parseInt(difficulty),
      passed: success,
    }
  } catch (error) {
    throw new Error(`Error en tirada de habilidad: ${error.message}`)
  }
}

/**
 * Funciones auxiliares
 */
function getSpellManaCost(spellName) {
  const spellCosts = {
    'bola de fuego': 15,
    'curar heridas': 10,
    'escudo mágico': 8,
    rayo: 12,
    invisibilidad: 20,
    teletransporte: 25,
  }

  return spellCosts[spellName.toLowerCase()] || 10
}

function getSkillModifier(skill, character) {
  if (!character) return 0

  const skillMappings = {
    fuerza: character.strength || 10,
    agilidad: character.agility || 10,
    inteligencia: character.intelligence || 10,
    carisma: character.charisma || 10,
    percepción: character.perception || 10,
    sigilo: character.stealth || 10,
    atletismo: character.athletics || 10,
    supervivencia: character.survival || 10,
  }

  const statValue = skillMappings[skill.toLowerCase()] || 10
  return Math.floor((statValue - 10) / 2) // Modificador D&D style
}

/**
 * Mapa de todas las acciones disponibles
 */
export const gameActions = {
  // Navegación
  leaveAdventure,
  joinAdventure,

  // Combate
  attackTarget,
  defendSelf,
  fleeFromCombat,

  // Magia
  castSpell,
  healTarget,

  // Inventario
  useItem,
  equipItem,

  // Información
  showCharacterStats,
  showInventory,

  // Social
  whisperToPlayer,
  shoutMessage,

  // Dados
  rollDice,
  skillCheck,
}

export default gameActions
